import React from 'react';
import { Icons } from '@hmsexp/component-library';
import get from 'lodash/get';

export function getChartExportsMenuItems(item) {
  return [
    {
      title: 'Export',
      icon: <Icons.UploadIcon />,
      items: get(item, 'actionItems', [])
    }
  ];
}
